export default "__VITE_ASSET__CpaFc3Wf__"